/*
 * Recently Viewed — component-recently-viewed.js
 *
 * <ecx-recently-viewed-tracker>  records the current product handle in localStorage.
 * <ecx-recently-viewed>          reads stored handles, fetches each card via Section Rendering
 *                                 API, and injects a real ecx-carousel on the page.
 */
(function () {
  var RV_KEY = "ecx:recently-viewed";
  var RV_MAX = 20;

  function readHandles() {
    try {
      return JSON.parse(localStorage.getItem(RV_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  /* ── Tracker ──────────────────────────────────────────────────────────────── */

  if (!customElements.get("ecx-recently-viewed-tracker")) {
    class ECXRecentlyViewedTracker extends HTMLElement {
      connectedCallback() {
        var handle = this.dataset.handle;
        if (!handle) return;
        var list = readHandles().filter(function (h) { return h !== handle; });
        list.unshift(handle);
        if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
        try {
          localStorage.setItem(RV_KEY, JSON.stringify(list));
        } catch (e) { /* private/full storage — ignore */ }
      }
    }
    customElements.define("ecx-recently-viewed-tracker", ECXRecentlyViewedTracker);
  }

  /* ── Display ──────────────────────────────────────────────────────────────── */

  if (!customElements.get("ecx-recently-viewed")) {
    class ECXRecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.$ = this.querySelector.bind(this);
      }

      connectedCallback() {
        var self = this;
        this.limit = parseInt(this.dataset.limit, 10) || 4;
        this.excludeHandle = this.dataset.excludeHandle || "";
        this.productSection = this.dataset.productSection || "recently-viewed-product";

        this.handles = readHandles()
          .filter(function (h) { return h && h !== self.excludeHandle; })
          .slice(0, this.limit);

        // The inline sync script in the Liquid already hid the section wrapper when there is no
        // history. This fallback handles the localStorage-unavailable edge case.
        if (!this.handles.length) {
          var wrapper = this.closest(".shopify-section") || this.parentElement;
          if (wrapper) wrapper.style.display = "none";
          return;
        }

        this.render();
      }

      get rootUrl() {
        return (window.routes && window.routes.root_url) || "/";
      }

      fetchCard(handle) {
        var url = this.rootUrl.replace(/\/$/, "") + "/products/" + handle
          + "?section_id=" + this.productSection;
        return fetch(url)
          .then(function (r) { return r.ok ? r.text() : ""; })
          .then(function (html) {
            if (!html.trim()) return "";
            var wrap = document.createElement("div");
            wrap.innerHTML = html;
            var card = wrap.querySelector(".js-rv-card");
            return card ? card.innerHTML : "";
          })
          .catch(function () { return ""; });
      }

      buildCarousel(cardsHtml) {
        var carouselTpl = this.$(".js-rv-carousel-template");
        var itemTpl = this.$(".js-rv-item-template");
        var fragment = carouselTpl.content.cloneNode(true);
        var container = fragment.querySelector(".js-rv-items");
        cardsHtml.forEach(function (html) {
          var item = itemTpl.content.cloneNode(true);
          item.querySelector(".js-rv-item-card").innerHTML = html;
          container.appendChild(item);
        });
        return fragment;
      }

      render() {
        var self = this;
        var target = this.$(".js-rv-target");
        if (!target) return;

        Promise.all(this.handles.map(function (h) { return self.fetchCard(h); }))
          .then(function (cards) {
            var valid = cards.filter(Boolean);
            if (!valid.length) {
              var wrapper = self.closest(".shopify-section") || self.parentElement;
              if (wrapper) wrapper.style.display = "none";
              return;
            }

            target.appendChild(self.buildCarousel(valid));

            // Fade cards in after they are in the DOM so the appearance is smooth.
            requestAnimationFrame(function () {
              target.classList.add("recently-viewed__target--loaded");
            });

            if (typeof ECXElementLazyLoad !== "undefined") new ECXElementLazyLoad();
          });
      }
    }
    customElements.define("ecx-recently-viewed", ECXRecentlyViewed);
  }
})();
